export const IFRAME_BASE_URL = 'https://m.gigmor.com';

/**
 * The PWA splash lives on `/`. Deep-linking the iframe at `/tabs/home` skips it
 * and AuthGuard immediately sends logged-out users to `/authentication`.
 *
 * Always enter through `/`. Pass a `next` path so the splash can continue to
 * the intended screen afterwards.
 */
export function iframeEntryUrl(path?: string | null): string {
  const next = normalizeIframePath(path);
  if (!next || next === '/' || next === '/tabs/home') {
    return `${IFRAME_BASE_URL}/`;
  }
  return `${IFRAME_BASE_URL}/?next=${encodeURIComponent(next)}`;
}

function normalizeIframePath(path?: string | null): string | null {
  if (!path) {
    return null;
  }
  if (path.startsWith('http')) {
    try {
      const url = new URL(path);
      return `${url.pathname}${url.search}`;
    } catch {
      return null;
    }
  }
  return path.startsWith('/') ? path : `/${path}`;
}
